import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';

// LogRocket Keys
export const LOGROCKET_REGISTRY_WEDDING_WEBSITE = 'logrocket-registry-wedding-website'; //
export const LOGROCKET_ALBUM_CUSTOMIZATION = 'logrocket-album-customization'; // COMMERCE-172 https://newamsterdamlabs.atlassian.net/browse/COMMERCE-172
export const LOGROCKET_PLANNING_ONBOARD_FLAG = 'logrocket-planning-onboard';
export const LOGROCKET_WEBSITE_ONBOARD = 'logrocket-website-onboard';
export const SUPER_LINK_LOG_ROCKET = 'magic-link-log-rocket'; // CE-847 https://newamsterdamlabs.atlassian.net/browse/CE-847
export const LOGROCKET_INVITES_PLP = 'logrocket-invites-plp'; // COMMERCE-584 https://newamsterdamlabs.atlassian.net/browse/COMMERCE-584
export const LOGROCKET_INVITES_PDP = 'logrocket-invites-pdp'; // COMMERCE-585 https://newamsterdamlabs.atlassian.net/browse/COMMERCE-585

// Experiment Keys
export const INVITES_PROMO_PAPER40 = 'invites-promo-paper40';
export const EDIT_PAGE_FORM = 'edit-page-form';
export const SKIP_REG_ONBOARDING_FOR_EXISTING = 'skip-reg-onboard-for-existing-2'; // newamsterdamlabs.atlassian.net/browse/CE-1179
export const REGISTRY_GIFT_GIVER_PDP = 'registry-gift-giver-pdp'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-479
export const REGISTRY_GIFT_GIVER_FILTERS = 'registry-gift-giver-filters'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-560
export const CARDS_BIGGER_THUMBNAILS = 'cards-bigger-thumbnails'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-705
export const DESKTOP_TO_APP_MODALS = 'desktop-to-app-modals'; // https://newamsterdamlabs.atlassian.net/browse/CE-1352
export const HOME_PROFILE_SECTION = 'home-updates-profile-section'; // https://newamsterdamlabs.atlassian.net/browse/CE-1322
export const SINGLE_PAGE_PAPER_ONBOARD = 'single-page-paper-onboard'; // https://newamsterdamlabs.atlassian.net/browse/CE-1397
export const HOME_NEWNESS = 'home-newness';
export const HOLIDAYS_2021 = 'holidays2021';

const FALLBACK_VARIATIONS = {
  // LogRocket Flags
  [LOGROCKET_PLANNING_ONBOARD_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_WEBSITE_ONBOARD]: experimentFlagsHelper.createExperimentFlags(),
  [SUPER_LINK_LOG_ROCKET]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_ALBUM_CUSTOMIZATION]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_REGISTRY_WEDDING_WEBSITE]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_INVITES_PLP]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_INVITES_PDP]: experimentFlagsHelper.createExperimentFlags(),
  // Experiment Flags
  [INVITES_PROMO_PAPER40]: experimentFlagsHelper.createExperimentFlags(),
  [EDIT_PAGE_FORM]: experimentFlagsHelper.createExperimentFlags(),
  [SKIP_REG_ONBOARDING_FOR_EXISTING]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_PDP]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_FILTERS]: experimentFlagsHelper.createExperimentFlags(),
  [CARDS_BIGGER_THUMBNAILS]: experimentFlagsHelper.createExperimentFlags(),
  [HOME_PROFILE_SECTION]: experimentFlagsHelper.createExperimentFlags(),
  [DESKTOP_TO_APP_MODALS]: experimentFlagsHelper.createExperimentFlags(),
  [SINGLE_PAGE_PAPER_ONBOARD]: experimentFlagsHelper.createExperimentFlags(),
  [HOME_NEWNESS]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAYS_2021]: experimentFlagsHelper.createExperimentFlags(),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);
